import axios from 'axios'
import store from '@/store'
import { message } from 'ant-design-vue'
import router from '@/router'
// import { Spin } from 'view-design'

class HttpRequest {
  constructor(public baseUrl, public queue = {}) {
    this.baseUrl = baseUrl
    this.queue = {}
  }
  getInsideConfig() {
    const config = {
      baseURL: this.baseUrl,
      headers: {
        //
      }
    }
    return config
  }
  destroy(url) {
    delete this.queue[url]
    if (!Object.keys(this.queue).length) {
      // Spin.hide()
    }
  }
  interceptors(instance, url) {
    // 请求拦截
    instance.interceptors.request.use(config => {
      // 添加全局的loading...
      if (!Object.keys(this.queue).length) {
        // Spin.show() // 不建议开启，因为界面不友好
      }
      this.queue[url] = true

      const token = localStorage.getItem('token')
      if (token) {
        config.headers['x-token'] = token
      }
      return config
    }, error => {
      return Promise.reject(error)
    })
    // 响应拦截
    instance.interceptors.response.use(res => {
      this.destroy(url)
      const { data, status } = res
      return data
    }, error => {

      this.destroy(url)
      let errorInfo = error.response
      if (!errorInfo) {
        const { request: { statusText, status }, config } = JSON.parse(JSON.stringify(error))
        message.error('网络异常')
        errorInfo = {
          statusText,
          status,
          request: { responseURL: config.url }
        }
      }
      else {
        const { code, msg } = errorInfo.data

        if (code == -1) {
          message.error(msg.replaceAll('"', ""))
        }
        else if (code == -2) {
          router.replace('/login')
        }
      }


      return Promise.reject(error)
    })
  }
  request(options) {
    const instance = axios.create()
    options = Object.assign(this.getInsideConfig(), options)
    this.interceptors(instance, options.url)
    return instance(options) as any
  }
}
export default HttpRequest
